import { stimulusApplication } from "web-ui/controllers"
import * as MorphStreamAction from "web-ui/turbo/stream-actions/morph"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as ConfirmationDialog from "web-ui/confirmation-dialog"
import * as Log from "web-ui/log"
import * as Tooltip from "web-ui/tooltip"
import "web-ui/turbo"
import "web-ui/scroll-to-on-load"

ConfirmationDialog.activate()
Tooltip.activate()

export {
  stimulusApplication,
  MorphStreamAction,
  morphdomIgnore,
  Log,
  Tooltip
}
